/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useCallback, useRef } from "react";
import { Button, Form, Input, Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";

import ResendOTP from "../Content/ResendOTP";

const { Text } = Typography;

const TwoFactorRequiredForm = ({
  loading,
  onSubmit = () => {},
  onResend,
  email = "",
  resendLoading,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const otpRef = useRef(null);

  const formatter = useCallback((str) => str.replace(/[^0-9]/g, ""), []);

  const handleResetOTP = useCallback(() => {
    form.setFieldValue("code", "");
    if (otpRef.current) {
      otpRef.current.focus();
    }
  }, [form]);

  const handleSubmit = useCallback(
    (values) => {
      onSubmit(values, handleResetOTP);
    },
    [onSubmit, handleResetOTP]
  );

  const handleChangeOTP = useCallback(
    (str) => {
      if (str.length === 6) {
        handleSubmit({ code: str });
      }
    },
    [handleSubmit]
  );

  const onKeyDownOtp = useCallback((event) => {
    if (event.code === "Enter") {
      event.preventDefault();
    }
  }, []);

  return (
    <Form
      layout="vertical"
      onFinish={onSubmit}
      style={{ marginTop: 30 }}
      form={form}
    >
      <Form.Item
        name="code"
        rules={[
          {
            required: true,
            message: t("task.please_input", { value: t("users.verify_code") }),
          },
        ]}
        style={{ textAlign: "center" }}
      >
        <Input.OTP
          ref={otpRef}
          inputType="number"
          length={6}
          autoFocus
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "16px",
            width: 300,
            margin: "0 auto",
          }}
          formatter={formatter}
          onChange={handleChangeOTP}
          onKeyDown={onKeyDownOtp}
          size="large"
        />
      </Form.Item>
      <div className="text-center mt-10">
        <Button
          block
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={loading}
        >
          {t("users.verify_code")}
        </Button>
      </div>
      {typeof onResend === "function" && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <div>
            <Text type="secondary">
              {t("users.not_receive_verification_code_from_email")}
            </Text>
          </div>
          <div>
            <Text type="secondary">
              {t("users.please_check_your_email_folder_spam")}
            </Text>
          </div>
          <ResendOTP
            hideDescription
            onResend={onResend}
            loading={resendLoading}
            canResendWithChannel
          />
        </div>
      )}
      <div className="text-center" style={{ marginTop: 20 }}>
        <Text type="secondary">
          <Trans
            i18nKey="users.need_help"
            values={{
              callCenterLink: t("users.sales_contact"),
            }}
            components={{
              a: (
                <a
                  className="text-primary"
                  href={`https://api.whatsapp.com/send?phone=6285232300100&text=Saya%20user%20gajihub%20dengan%20email%20${email}%20mengalami%20kendala%20login.`}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </Text>
      </div>
    </Form>
  );
};

export default TwoFactorRequiredForm;
